var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderSummaryTotal
    ? _c("section", [
        _c("div", { staticClass: "row pb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c("h4", [
              _vm._v(
                _vm._s(_vm.$t("message.my_reservations.summary_total.title"))
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row pb-1" }, [
          _c("div", { staticClass: "col-9" }, [
            _vm._v(
              _vm._s(_vm.$t("message.my_reservations.summary_total.subtotal"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-3 text-right" }, [
            _vm._v(_vm._s(_vm._f("currency")(_vm.orderSummaryTotal.subtotal)))
          ])
        ]),
        _vm._v(" "),
        _vm.order.extra
          ? _c("div", { staticClass: "row pb-1" }, [
              _c("div", { staticClass: "col-9" }, [
                _vm._v(_vm._s(_vm._f("multiLangName")(_vm.order.extra)))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 text-right" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("currency")(_vm.orderSummaryTotal.extra_cost)
                    ) +
                    "\n    "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.orderSummaryTotal.promo_code_usage &&
        _vm.orderSummaryTotal.promo_code_usage.applied
          ? _c("div", { staticClass: "row pb-1" }, [
              _c("div", { staticClass: "col-9" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("message.my_reservations.summary_total.discount")
                    ) +
                    ":\n      " +
                    _vm._s(_vm.orderSummaryTotal.promo_code_usage.code) +
                    "\n      (" +
                    _vm._s(_vm.orderSummaryTotal.promo_code_usage.discount) +
                    "%)\n    "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 text-right -status-discount" }, [
                _vm._v(
                  "\n      -" +
                    _vm._s(
                      _vm._f("currency")(_vm.orderSummaryTotal.discount_cost)
                    ) +
                    "\n    "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.is_new_cost_format
          ? _c("section", [
              _vm.orderSummaryTotal.service_vat
                ? _c("div", { staticClass: "row mt-1" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message.my_reservations.summary_total.service_vat"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-3 text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("currency")(_vm.orderSummaryTotal.service_vat)
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderSummaryTotal.credit_discount_cost
                ? _c("div", { staticClass: "row mt-1" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.discount_credits"
                            )
                          ) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-3 text-right -status-discount" },
                      [
                        _vm._v(
                          "\n        -" +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.orderSummaryTotal.credit_discount_cost
                              )
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          : _c("section", [
              _vm.orderSummaryTotal.credit_discount_cost
                ? _c("div", { staticClass: "row mt-1" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.discount_credits"
                            )
                          ) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-3 text-right -status-discount" },
                      [
                        _vm._v(
                          "\n        -" +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.orderSummaryTotal.credit_discount_cost
                              )
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderSummaryTotal.service_vat
                ? _c("div", { staticClass: "row mt-1" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message.my_reservations.summary_total.service_vat"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-3 text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("currency")(_vm.orderSummaryTotal.service_vat)
                        )
                      )
                    ])
                  ])
                : _vm._e()
            ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-9" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("message.my_reservations.summary_total.total"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-3 text-right" }, [
            _c("label", [
              _vm._v(_vm._s(_vm._f("currency")(_vm.orderSummaryTotal.total)))
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cfd6d08", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfd6d08","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/OrderSummaryTotalShort.vue
// module id = 1709
// module chunks = 0